import React from "react";
import CountUp from "react-countup";
import {
  FaBuilding,
  FaUsers,
  FaUserFriends,
  FaAddressBook,
  FaDatabase,
} from "react-icons/fa";
import styles from "./main.module.css";



function HomepageCounter() {
  return (
    <div className={styles.homecounter_main}>
      <div className={styles.homecounter}>
        <div className={styles["counter-item"]}>
          <div className={styles.homecountericon}>
            <FaBuilding />
          </div>
          <div className={styles.textContainer}>
            <h2>
              <CountUp start={0} end={2700000} duration={3} separator="," /> +
            </h2>
            <p>Companies Data</p>
          </div>
        </div>
        <div className={styles["counter-item"]}>
          <div className={styles.homecountericon}>
            <FaAddressBook />
          </div>
          <div className={styles.textContainer}>
            <h2>
              <CountUp start={0} end={300000} duration={3} separator="," /> +
            </h2>
            <p>LLP Data</p>
          </div>
        </div>
        <div className={styles["counter-item"]}>
          <div className={styles.homecountericon}>
            <FaUsers />
          </div>
          <div className={styles.textContainer}>
            <h2>
              <CountUp start={0} end={5000000} duration={3} separator="," /> +
            </h2>
            <p>Directors Data</p>
          </div>
        </div>
        <div className={styles["counter-item"]}>
          <div className={styles.homecountericon}>
            <FaUserFriends />
          </div>
          <div className={styles.textContainer}>
            <h2>
              <CountUp start={0} end={1000000} duration={3} separator="," /> +
            </h2>
            <p>Professionals Data</p>
          </div>
        </div>
        <div className={styles["counter-item"]}>
          <div className={styles.homecountericon}>
            <FaDatabase />
          </div>
          <div className={styles.textContainer}>
            <h2>
              <CountUp start={0} end={500} duration={3} separator="," /> +
            </h2>
            <p>Data Sources</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomepageCounter;
